var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    { staticClass: "svg-container" },
    [
      _vm._l(_vm.connectors(), function (path) {
        return _c("path", { key: path.id, attrs: { d: path.path } })
      }),
      _vm._v(" "),
      _vm._l(
        _vm.connectors().filter(function (x) {
          return _vm.isSelected(x.id)
        }),
        function (path) {
          return _c("path", {
            key: path.id + "-selected",
            staticClass: "selected",
            attrs: { d: path.path },
          })
        }
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }